// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bfc35e20","453":"582fdce3","455":"5e4ea8b9","977":"12f12cfd"}[chunkId] + ".chunk.js";
};